<template>
  <div class="plv-ia-checkin-start">
    <div class="plv-ia-checkin-start__body">
      <div class="plv-ia-checkin-start__row plv-ia-checkin-start__row__tips">
        <span class="plv-ia-checkin-start__row__left">{{ t('plvIA.checkIn.tips') }}</span>
        <div class="plv-ia-checkin-start__row__right">
          <div class="plv-ia-checkin-start__input">
            <input
              v-model="tips"
              maxlength="12"
              type="text"
              :placeholder="t('plvIA.checkIn.startTips')"
            />
            <span class="plv-ia-checkin-start__input__count">{{ tips.length }}/12</span>
          </div>
        </div>
      </div>
      <div class="plv-ia-checkin-start__row plv-ia-checkin-start__row__duration">
        <span class="plv-ia-checkin-start__row__left">{{ t('plvIA.checkIn.duration') }}</span>
        <div class="plv-ia-checkin-start__row__right">
          <div class="plv-ia-checkin-start__input">
            <input
              v-model="duration"
              class="plv-ia-checkin-start-content__modal__form__input plv-ia-checkin-start-content__form__time"
              type="text"
              maxlength="5"
              :placeholder="`${durationRange[0]}~${durationRange[1]}`"
              @keyup="numberLimit"
            />
          </div>
          <span>{{ t('plvIA.checkIn.seconds') }}</span>
          <span
            v-if="right.showHistoryEntry"
            class="plv-ia-btn-text pws-vclass-btn-text"
            @click="showHistory"
          >{{ t('plvIA.checkIn.historyRecords') }}</span>
        </div>
      </div>
    </div>
    <div class="plv-ia-checkin-start__footer">
      <button
        class="plv-ia-btn-new plv-ia-btn-blue pws-vclass-btn-blue"
        type="button"
        @click="handleStart"
      >
        {{ t('plvIA.checkIn.startCheckedIn') }}
      </button>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';

export default {
  mixins: [Locale],
  props: {
    initialTips: {
      type: String,
      default: '',
    },
    initialDuration: {
      type: Number,
      default: 0,
    },
    right: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      durationRange: [1, 9999],
      tips: this.initialTips,
      duration: this.initialDuration,
    };
  },

  watch: {
    initialTips() {
      if (this.initialTips) this.tips = this.initialTips;
    },

    initialDuration() {
      if (this.initialDuration) this.duration = this.initialDuration;
    }
  },

  methods: {
    limitNumberCalculate(value, length = 10) {
      value = value.replace(/[^\d]/g, '');
      value = parseInt(value || 0, 10);
      const str = value.toString();
      if (str.length >= length) {
        value = str.slice(0, length);
      }
      return value;
    },

    numberLimit() {
      const [min, max] = this.durationRange;
      this.duration = this.limitNumberCalculate(this.duration.toString());
      if (this.duration < min) {
        this.duration = '';
      } else if (this.duration > max) {
        this.duration = max;
      }
    },

    handleStart() {
      if (!this.duration || !this.tips) return;

      this.$emit('start', {
        tips: this.tips,
        duration: this.duration,
      });
    },

    showHistory() {
      this.$emit('show-history');
    }
  }
};
</script>
<style lang="scss">
$color: #2196f3;

.plv-ia-checkin-start__body {
  padding-top: 96px;
}

.plv-ia-checkin-start__row {
  width: 312px;
  margin: 0 auto;
  position: relative;
  line-height: 32px;
  >* {
    height: 32px;
  }

  +.plv-ia-checkin-start__row {
    margin-top: 24px;
  }
}

.plv-ia-checkin-start__row__left {
  color: #606266;
  text-align: right;
  width: 56px;
  position: absolute;
  left: 0;
}

.plv-ia-checkin-start__row__right {
  width: 100%;
  box-sizing: border-box;
  padding-left: 56px + 16px; // 16px 是padding
}

.plv-ia-checkin-start__input {
  line-height: 30px;
  border-radius: 2px;
  border: 1px solid #D8D8D8;
  padding: 0 15px;
  color: #333;
  box-sizing: border-box;
  position: relative;

  input {
    outline: none;
    border: 0;
    font-size: 14px;
  }
}

.plv-ia-checkin-start__input__count {
  font-size: 12px;
  color: #999;
  position: absolute;
  right: 6px;
  top: 0;
  text-align: right;
}

.plv-ia-checkin-start__row__tips {
  .plv-ia-checkin-start__input {
    width: 100%;

    input {
      width: 100%;
      padding-right: 35px;
      box-sizing: border-box;
    }
  }
}

.plv-ia-checkin-start__row__duration {
  .plv-ia-checkin-start__input {
    width: 80px;
    display: inline-block;
    margin-right: 0.5em;

    input {
      width: 100%;
    }
  }

  .plv-ia-btn-text {
    float: right;
  }
}

.plv-ia-checkin-start__footer {
  padding-top: 40px;
  text-align: center;
}

</style>
